import { useEffect, useState } from "react";
import { useAuth } from "../navigation/AuthProvider";
import { normalizeRole } from "../permissions/rolePermissions";
import { get_history_access } from "./historyRequests";

// Avgör om inloggad användare får se "Historik" (visar/döljer menyvalet).
// Servern avgör på riktigt – det här är bara för att visa rätt meny. Svaret cachas så att
// menyn inte frågar servern vid varje sidbyte.
const cache = new Map();

export const rememberHistoryAccess = (user, company, value) => {
  if (user && company) cache.set(`${user._id}:${company._id}`, value);
};

export const useHistoryAccess = () => {
  const { user, company } = useAuth();
  const key = user && company && user._id && company._id ? `${user._id}:${company._id}` : null;
  const isSuper = normalizeRole(user?.role) === "superadmin";

  const [state, setState] = useState(
    () => (key && cache.get(key)) || { loading: !isSuper, canView: isSuper, isSuperAdmin: isSuper }
  );

  useEffect(() => {
    if (!key) return;
    if (cache.has(key)) {
      setState(cache.get(key));
      return;
    }

    let cancelled = false;
    get_history_access({ user, company })
      .then((data) => {
        const value =
          data && data.status === "success"
            ? { loading: false, canView: !!data.canView, isSuperAdmin: !!data.isSuperAdmin }
            : { loading: false, canView: isSuper, isSuperAdmin: isSuper };
        cache.set(key, value);
        if (!cancelled) setState(value);
      })
      .catch(() => {
        if (!cancelled) setState({ loading: false, canView: isSuper, isSuperAdmin: isSuper });
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return state;
};
